/*
    question-types.js

    These determine which UI control to render for Referral questions.

        export const CONTACT_INFO = {
            sectionId: "contact-info",
            sectionlabel: "Contact Information",
            questions: [
                {
                    id: "0000-0000",
                    questionType: SHORT_TEXT,
                    label: "What is yur favorite service at TCARE?",
                    options: null,
                    value: null
                },
                {
                    id: "0000-0001",
                    questionType: SINGLE_CHOICE,
                    label: "What is your favorite color?",
                    options: [
                        {label: "Red", value: "red"},
                        {label: "Green", value: "green"},
                        {label: "Blue", value: "blue"}
                    ],
                    value: null
                },
                {
                    id: "0000-0002",
                    questionType: MULTI_CHOICE,
                    label: "What kind of help will you need while you are away?",
                    options: [
                        {label: "Respite Care", value: "respite care"},
                        {label: "Petsitting", value: "petsitting"},
                        {label: "Child Daycare", value: "child daycare"}
                    ],
                    value: null
                }
            ]
        }


*/

// question types - must match!
export const SHORT_TEXT = "short_text";
export const LONG_TEXT = "long_text";
export const SINGLE_CHOICE = "single_choice";
export const MULTI_CHOICE = "multi_choice";
export const NUMBER = "number";
export const DATE = "date";
export const COMMENT = "comment";
export const SELECTION = "selection";
export const BOOLEAN_CHECKBOX = "boolean_checkbox";
export const RATING_STARS = "rating_stars";
export const OBJECT = "object";


// prop names - must match!
export const VALUE = "value";
export const QUESTION_TYPE = "questionType";
export const IS_REQUIRED = "isRequired";
export const OPTIONS = "options";
export const LABEL = "label";
export const CSS_CLASS = "cssClass";
export const IS_READONLY = "isReadOnly";
export const PLACEHOLDER = "placeholder";


// these will be pre-formatted for screen UI fields
// both frontend and backend must agree on the fields
export const CONTACT_INFO = "contact_info";
export const MYSELF_INFO = "myself_info";
